import { clearLocalStorageExceptPersisted } from '@/utils/storage/persistedStorage';
import Cookies from 'js-cookie';

/**
 * format result of  date picker
 * @param {*} date
 * @param {string} date.$y
 * @param {string} date.$M
 * @param {string} date.$D
 * @returns
 */
const isSuperAdmin = Cookies.get('role');
const clearAllCookies = () => {
  const allCookies = Cookies.get(); // Get all cookies
  Object.keys(allCookies).forEach((cookie) => Cookies.remove(cookie)); // Remove each cookie
};

export const formatAntDDate = (date) => {
  return `${date.$y}-${String(date.$M).padStart(2, 0)}-${String(date.$D).padStart(2, 0)}`;
};

export const decodeBase64 = (value) => atob(value);
export const encodeBase64 = (value) => btoa(value);

export const handleBase64Image = (encodedData) => {
  if (!encodedData) return null;

  return `data:image/png;base64,${encodedData}`;
};

/**
 *
 * @param {*} value
 * @param {*} option
 * @returns
 */
export const optionSearchFunction = (value, option) => {
  return option?.label.toLowerCase().includes(value.trim().toLowerCase());
};

export const goToDashboard = () => '/dashboard';
export const goToAdminDashboard = () => '/admin/dashboard/';

export const Logout = () => {
  sessionStorage.clear();
  clearLocalStorageExceptPersisted();
  clearAllCookies();
  window.location.replace('/login/');
};

export const AdminLogout = (navigate, isSuperAdmin) => {
  sessionStorage.clear();
  clearLocalStorageExceptPersisted();
  clearAllCookies();
  navigate(
    isSuperAdmin === 'superadmin' ? '/superadmin/login/' : '/admin/login/',
    {
      replace: true,
    },
  );
};

/**
 * scroll to the top
 * @returns
 */
export const scrollToTop = () => window.scrollTo(0, 0);

// convert image to base64 image
export const imageToBase64 = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const base64ToFile = (base64, filename) => {
  let arr = base64.split(',');
  let mime = arr[0].match(/:(.*?);/)[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

/**
 * highlight method
 */

export const highlight = (value, query) => {
  const regex = new RegExp(value, 'gi');
  return regex.replace(
    regex,
    `<span style={{ color: 'green' }}>${query}</span>`,
  );
};

/**
 *
 * @param {boolean} isLoading
 * @param {Object []} data
 * @returns
 */
export const enablePaginationOrNot = (data) => {
  if (!data?.length) return;

  return !!data.length > 10;
};
